<template>
<div class="chapter">
<div class="inner_page">
<p> </p>
<p class="copy"><b>PUBLISHER:</b> Amy Marson</p>
<p class="copy"><b>CREATIVE DIRECTOR:</b> Gailen Runge</p>
<p class="copy"><b>ART DIRECTOR:</b> Kristy Zacharias</p>
<p class="copy"><b>EDITOR:</b> Liz Aneloski</p>
<p class="copy"><b>TECHNICAL EDITORS:</b> Doreen Hazel and Gailen Runge</p>
<p class="copy"><b>COVER/BOOK DESIGNER:</b> April Mostek</p>
<p class="copy"><b>PRODUCTION COORDINATOR:</b> Rue Flaherty</p>
<p class="copy"><b>PRODUCTION EDITOR:</b> Joanna Burgarino</p>
<p class="copy"><b>ILLUSTRATOR:</b> Jessica Jenkins</p>
<p class="copy"><b>PHOTO ASSISTANT:</b> Mary Peyton Peppo</p>
<p class="copy"><b>STYLED PHOTOGRAPHY</b> by Nissa Brehmer and<br/><b>INSTRUCTIONAL PHOTOGRAPHY</b> by Diane Pedersen, unless otherwise noted</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_copyright.vue?6098a364